/* ============================================================
   AMP3 information pages (About, Trade, Help Centre, Contact).
   Progressive enhancement only: every page is complete without it.
   1. Retailer logos: static grid → gentle seamless marquee.
   2. Trade brand links: add the brand to a "brands" field if the form has one.
   3. Contact topic: hint towards the trade form for trade enquiries.
   4. Help Centre: search, topic filtering and policy deep links.
   ============================================================ */
(function () {
  'use strict';
  var q = function (s, root) { return (root || document).querySelector(s); };
  var all = function (s, root) { return [].slice.call((root || document).querySelectorAll(s)); };

  /* ---------- 1. Retailer carousel ---------- */
  all('[data-retailer-carousel]').forEach(function (carousel) {
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var controls = q('.a3i-retailer-controls', carousel);
    var pause = q('[data-retailer-pause]', carousel);
    var showAll = q('[data-retailer-all]', carousel);
    var count = all('.a3i-retailer-group:not(.a3i-retailer-copy) li', carousel).length;
    var expanded = false, paused = false;
    function render() {
      var staticView = expanded || motion.matches;
      carousel.classList.toggle('is-scrolling', !staticView);
      carousel.classList.toggle('is-paused', paused);
      controls.hidden = motion.matches;
      pause.hidden = staticView;
      pause.textContent = paused ? 'Resume scrolling' : 'Pause scrolling';
      showAll.textContent = expanded ? 'Back to scrolling logos' : 'Show all ' + count + ' retailers';
      showAll.setAttribute('aria-expanded', String(staticView));
    }
    pause.addEventListener('click', function () { paused = !paused; render(); });
    showAll.addEventListener('click', function () { expanded = !expanded; render(); });
    if (motion.addEventListener) motion.addEventListener('change', render);
    render();
  });

  /* ---------- 2. Trade brand enquiry links ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-trade-brand]');
    if (!link) return;
    var field = q('#trade-enquiry input[name*="brand" i], #trade-enquiry textarea[name*="brand" i]');
    if (!field) return;
    var current = field.value.split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    if (current.indexOf(link.dataset.tradeBrand) === -1) current.push(link.dataset.tradeBrand);
    field.value = current.join(', ');
    field.dispatchEvent(new Event('input', { bubbles: true }));
  });

  /* ---------- 3. Contact topic hint ---------- */
  var topic = q('#a3i-contact-topic');
  if (topic) {
    var hint = q('#a3i-contact-trade-hint');
    var sync = function () { hint.hidden = topic.value !== 'Trade and distribution'; };
    topic.addEventListener('change', sync);
    sync();
  }

  /* ---------- 4. Help Centre ---------- */
  var layout = q('.a3i-help-layout');
  if (!layout) return;
  var groups = all('.a3i-faq-group', layout);
  var search = q('#a3i-help-search');
  var clear = q('#a3i-help-search-clear');
  var status = q('#a3i-help-search-status');
  var answersBox = q('#a3i-faq-answers');
  var policy = q('#returns-policy');
  var noResults = q('#a3i-help-no-results');
  var policyHint = q('#a3i-help-policy-search');
  var pagesBox = q('#a3i-help-pages');
  var pageRows = pagesBox ? all('[data-help-page]', pagesBox) : [];
  var total = all('.a3i-answer', layout).length;
  var legalText = policy.textContent.toLowerCase();
  var topic = layout.dataset.helpDefault;

  // Keep the topic counts honest if answers are added or removed.
  all('.a3i-help-nav [data-help-topic]').forEach(function (b) {
    var span = q('span', b);
    if (!span) return;
    var t = b.dataset.helpTopic;
    span.textContent = t === 'all' ? total : all('#' + t + ' .a3i-answer').length;
  });

  function valid(t) { return t === 'all' || t === 'policy' || groups.some(function (g) { return g.dataset.topic === t; }); }
  function plural(n) { return n + ' ' + (n === 1 ? 'answer' : 'answers'); }

  function render() {
    var query = search.value.trim().toLowerCase();
    var terms = query.split(/\s+/).filter(Boolean);
    var readingPolicy = topic === 'policy' && !query;
    var found = 0;
    policy.hidden = !readingPolicy;
    answersBox.hidden = readingPolicy;
    groups.forEach(function (g) {
      var visible = 0;
      all('.a3i-answer', g).forEach(function (a) {
        var text = a.textContent.toLowerCase();
        var match = query
          ? terms.every(function (t) { return text.indexOf(t) !== -1; })
          : topic === 'all' || topic === g.dataset.topic;
        a.hidden = !match;
        if (query) a.open = match;
        if (match) visible++;
      });
      g.hidden = visible === 0;
      found += visible;
    });
    var policyMatch = !!query && terms.every(function (t) { return legalText.indexOf(t) !== -1; });
    policyHint.hidden = !policyMatch;
    // Other pages (Price Beat, Trade & Distribution...): matched on their name and keywords.
    var pagesFound = 0;
    pageRows.forEach(function (li) {
      var words = li.dataset.helpPage;
      var match = !!query && terms.every(function (t) { return words.indexOf(t) !== -1; });
      li.hidden = !match;
      if (match) pagesFound++;
    });
    if (pagesBox) pagesBox.hidden = pagesFound === 0;
    noResults.hidden = readingPolicy || found > 0 || policyMatch || pagesFound > 0;
    status.textContent = readingPolicy
      ? 'Full Returns Policy · part of the AMP3 Help Centre'
      : query
        ? (found || !pagesFound ? plural(found) + ' found' + (pagesFound ? ' · ' : '') : '') + (pagesFound ? pagesFound + (pagesFound === 1 ? ' page' : ' pages') + (found ? '' : ' found') : '') + (policyMatch ? ' · Policy information also available' : '')
        : topic === 'all' ? total + ' answers. One helpful place.' : plural(found) + ' in this topic';
    clear.hidden = !query;
    all('.a3i-help-nav [data-help-topic]').forEach(function (b) {
      b.setAttribute('aria-current', String(!query && b.dataset.helpTopic === topic));
    });
  }

  function choose(t) {
    topic = valid(t) ? t : 'all';
    search.value = '';
    all('.a3i-answer[open]', layout).forEach(function (a) { a.open = false; });
    render();
    var hash = topic === 'all' ? '' : '#' + (topic === 'policy' ? 'returns-policy' : topic);
    history.replaceState(null, '', location.pathname + location.search + hash);
    layout.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-help-topic]');
    if (!b) return;
    e.preventDefault();
    choose(b.dataset.helpTopic);
  });
  search.addEventListener('input', function () { topic = 'all'; render(); });
  clear.addEventListener('click', function () { search.value = ''; topic = 'all'; render(); search.focus(); });

  // Old deep links: FAQ topic IDs select that topic; policy section IDs open the policy first.
  function fromHash() {
    var h = decodeURIComponent(location.hash.slice(1));
    var target = h && document.getElementById(h);
    var inPolicy = target && target !== policy && policy.contains(target);
    // 19 Oct 2026: a link to one answer (/pages/faqs#clearance-condition-labels) opens its topic and that answer
    var group = target && target.tagName === 'DETAILS' && target.closest && target.closest('[data-topic]');
    if (group && valid(group.getAttribute('data-topic'))) {
      topic = group.getAttribute('data-topic'); render(); target.open = true;
      requestAnimationFrame(function () { target.scrollIntoView({ block: 'start' }); });
      return;
    }
    if (h === 'returns-policy' || inPolicy) topic = 'policy';
    else if (valid(h)) topic = h;
    render();
    if (inPolicy) requestAnimationFrame(function () { target.scrollIntoView(); });
  }
  window.addEventListener('hashchange', fromHash);
  fromHash();
})();
